import React from 'react';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const SavingNotification = props => {
  if (props.showSaving) {
    return (
      <div
        className="bg-blur z-index-1001 pos-abs w-100-vw h-100-vh flex-row-nospacebetween-nowrap"
        style={{ justifyContent: 'center', backgroundColor: 'rgba(0, 0, 0, 0.2)' }}
      >
        <div
          className="z-index-1001 flex-col-center"
          style={{
            width: '90%',
            maxWidth: '260px',
            height: '180px',
            backgroundColor: '#4A5568',
            borderRadius: '12px',
            boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)',
          }}
        >
          <div className="d-grid">
            <FontAwesomeIcon
              icon={['far', 'spinner-third']}
              spin
              className="d-grid-stack"
              style={{ fontSize: '48px', color: '#FFFFFF' }}
            />
            <img
              alt="Clientbook"
              className="d-grid-stack"
              style={{ marginTop: '10px', marginLeft: '10px', width: '28px', height: '28px' }}
              src="/assets/CB_64x64_white.svg"
            />
          </div>
          <span className="white" style={{ fontSize: '16px', fontWeight: 500, marginTop: '24px' }}>
            Saving...
          </span>
        </div>
      </div>
    );
  }
  return null;
};
const mapStateToProps = state => state.notification;
export default connect(mapStateToProps, {})(SavingNotification);
